import logo from './logo.svg';
// import './App.css';
import Form from './Form.js'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Form name='Yeah'></Form>
      </header>
    </div>
  );
}

export default App;
